import React, {Component} from "react";
import Multiselect from 'multiselect-react-dropdown';

export default class Schedules extends Component {
    constructor() {
        super();
        this.state = {
            options: [],
            selectedValues: []
        }
    }

    componentDidMount() {
        this.setState({
            options: [
                {name: 'Gymnasium', id: 1},
                {name: 'Auditorium', id: 2},
                {name: 'Joe\'s Classroom', id: 3}
            ],
        })
        
    }

    onSelect = (selectedList, selectedItem) => {

    }

    onRemove = (selectedList, removedItem) => {

    }

    render() {
        return (
            <div className="subsearch-element">
            <Multiselect style={{multiselectContainer: {borderColor: "red"}}}
                options={this.state.options} // Options to display in the dropdown
                selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
                onSelect={this.onSelect} // Function will trigger on select event
                onRemove={this.onRemove} // Function will trigger on remove event
                displayValue="name" // Property name to display in the dropdown options
                placeholder="Schedules"
                showArrow={true}
                showCheckbox={true}
                avoidHighlightFirstOption={true}
            />

            </div>
        )
  }

}